var render = function render(){var _vm=this,_c=_vm._self._c;return _c('config-item',{attrs:{"label":_vm.label}},[_c('div',{staticClass:"wrap"},[_c('div',{staticClass:"pt5"},[_c('el-switch',{attrs:{"active-color":"#13ce66"},model:{value:(_vm.mValue),callback:function ($$v) {_vm.mValue=$$v},expression:"mValue"}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }